var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_vm._m(0),_c('b-button',{attrs:{"type":"is-primary","size":"is-small"}},[_vm._v(" no "+_vm._s(_vm.tableName)+" data found ")])],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/images/no-data.svg"),"alt":"No Data"}})])
}]

export { render, staticRenderFns }